const middleware = {}

middleware['captureUtmVariables'] = require('../../../src/middleware/captureUtmVariables.ts')
middleware['captureUtmVariables'] = middleware['captureUtmVariables'].default || middleware['captureUtmVariables']

middleware['checkTokenMigrationStatus'] = require('../../../src/middleware/checkTokenMigrationStatus.ts')
middleware['checkTokenMigrationStatus'] = middleware['checkTokenMigrationStatus'].default || middleware['checkTokenMigrationStatus']

middleware['dontShowGame'] = require('../../../src/middleware/dontShowGame.ts')
middleware['dontShowGame'] = middleware['dontShowGame'].default || middleware['dontShowGame']

middleware['gameAuth'] = require('../../../src/middleware/gameAuth.ts')
middleware['gameAuth'] = middleware['gameAuth'].default || middleware['gameAuth']

middleware['gameRedirect'] = require('../../../src/middleware/gameRedirect.ts')
middleware['gameRedirect'] = middleware['gameRedirect'].default || middleware['gameRedirect']

middleware['inventoryDisclaimer'] = require('../../../src/middleware/inventoryDisclaimer.ts')
middleware['inventoryDisclaimer'] = middleware['inventoryDisclaimer'].default || middleware['inventoryDisclaimer']

middleware['isAdmin'] = require('../../../src/middleware/isAdmin.ts')
middleware['isAdmin'] = middleware['isAdmin'].default || middleware['isAdmin']

middleware['loadRootCmsContent'] = require('../../../src/middleware/loadRootCmsContent.ts')
middleware['loadRootCmsContent'] = middleware['loadRootCmsContent'].default || middleware['loadRootCmsContent']

middleware['mixpanelRegisterSuperProperties'] = require('../../../src/middleware/mixpanelRegisterSuperProperties.ts')
middleware['mixpanelRegisterSuperProperties'] = middleware['mixpanelRegisterSuperProperties'].default || middleware['mixpanelRegisterSuperProperties']

middleware['mixpanelTrackRouteChange'] = require('../../../src/middleware/mixpanelTrackRouteChange.ts')
middleware['mixpanelTrackRouteChange'] = middleware['mixpanelTrackRouteChange'].default || middleware['mixpanelTrackRouteChange']

middleware['pathAliasRedirect'] = require('../../../src/middleware/pathAliasRedirect.ts')
middleware['pathAliasRedirect'] = middleware['pathAliasRedirect'].default || middleware['pathAliasRedirect']

middleware['redirectAfterLogin'] = require('../../../src/middleware/redirectAfterLogin.ts')
middleware['redirectAfterLogin'] = middleware['redirectAfterLogin'].default || middleware['redirectAfterLogin']

middleware['redirectToNode'] = require('../../../src/middleware/redirectToNode.ts')
middleware['redirectToNode'] = middleware['redirectToNode'].default || middleware['redirectToNode']

middleware['refreshToken'] = require('../../../src/middleware/refreshToken.ts')
middleware['refreshToken'] = middleware['refreshToken'].default || middleware['refreshToken']

middleware['requireAuth'] = require('../../../src/middleware/requireAuth.ts')
middleware['requireAuth'] = middleware['requireAuth'].default || middleware['requireAuth']

middleware['requireWallet'] = require('../../../src/middleware/requireWallet.ts')
middleware['requireWallet'] = middleware['requireWallet'].default || middleware['requireWallet']

middleware['routeBackAfterLogin'] = require('../../../src/middleware/routeBackAfterLogin.ts')
middleware['routeBackAfterLogin'] = middleware['routeBackAfterLogin'].default || middleware['routeBackAfterLogin']

middleware['routeHome'] = require('../../../src/middleware/routeHome.ts')
middleware['routeHome'] = middleware['routeHome'].default || middleware['routeHome']

middleware['routeNameToQueryParam'] = require('../../../src/middleware/routeNameToQueryParam.ts')
middleware['routeNameToQueryParam'] = middleware['routeNameToQueryParam'].default || middleware['routeNameToQueryParam']

middleware['savePreviousRoute'] = require('../../../src/middleware/savePreviousRoute.ts')
middleware['savePreviousRoute'] = middleware['savePreviousRoute'].default || middleware['savePreviousRoute']

middleware['setUser'] = require('../../../src/middleware/setUser.ts')
middleware['setUser'] = middleware['setUser'].default || middleware['setUser']

middleware['trackLoginEvent'] = require('../../../src/middleware/trackLoginEvent.ts')
middleware['trackLoginEvent'] = middleware['trackLoginEvent'].default || middleware['trackLoginEvent']

middleware['translate'] = require('../../../src/middleware/translate.ts')
middleware['translate'] = middleware['translate'].default || middleware['translate']

middleware['verifyEmail'] = require('../../../src/middleware/verifyEmail.ts')
middleware['verifyEmail'] = middleware['verifyEmail'].default || middleware['verifyEmail']

middleware['verifyIp'] = require('../../../src/middleware/verifyIp.ts')
middleware['verifyIp'] = middleware['verifyIp'].default || middleware['verifyIp']

export default middleware
